<template>
  <component :is="fill ? filledSymbolsMap[name] : symbolsMap[name]" :class="sizeValue" v-bind="attrs"></component>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import { Size } from '../gvIcon/types';
import { filledSymbolsMap, symbolsMap } from './constants';
import { tw } from '@/common/helpers';

export type GvIconProps = {
  name: string;
  fill?: boolean;
  size?: Size;
  ariaLabel?: string;
};

const props = withDefaults(defineProps<GvIconProps>(), {
  fill: false,
  size: 'md',
  ariaLabel: undefined,
});

const attrs = computed(() => {
  if (props.ariaLabel) {
    return { 'aria-label': props.ariaLabel };
  }
  // If no label is provided, it's safe to assume the icon is decorative.
  return { 'aria-hidden': true };
});

const sizeMap: Record<Size, string> = {
  '2xs': tw`size-3`,
  xs: tw`size-4`,
  sm: tw`size-5`,
  md: tw`size-6`,
  lg: tw`size-10`,
  xl: tw`size-12`,
  custom: '',
};

const sizeValue = computed(() => sizeMap[props.size]);
</script>
